import { render, staticRenderFns } from "./EmptyColumn2.vue?vue&type=template&id=3806202c&scoped=true&"
import script from "./EmptyColumn2.vue?vue&type=script&lang=js&"
export * from "./EmptyColumn2.vue?vue&type=script&lang=js&"
import style0 from "./EmptyColumn2.vue?vue&type=style&index=0&id=3806202c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806202c",
  null
  
)

export default component.exports